import React from 'react';
import { TextArea, TextAreaChangeEvent, TextBoxChangeEvent } from '@progress/kendo-react-inputs';
interface InputProps {
    name: string;
    value: string;
    onChange: (value: string | number | readonly string[] | undefined) => void;
    readOnly?: boolean;
}

const InputTextArea: React.FC<InputProps> = ({ name, value, onChange, readOnly }) => {
    const handleChange = (e: TextAreaChangeEvent) => {
        onChange(e.target.value);
    };


    return (
        <div className="textArea">
            <p>{name}</p>
            <TextArea
                autoSize={true}
                rows={4}
                value={value !== null ? value : ""}
                onChange={handleChange}
                required={false}
                readOnly={readOnly}
            />
        </div>
    );
};

export default InputTextArea;
